import getLibPhoneNumberMinMetaData from './getLibPhoneNumberMinMetaData'

/**
 * Preloading lib phone number meta data to make sure data available in sessiaon storage
 */
export const preloadLibPhoneNumberMetaData = () => {
	getLibPhoneNumberMinMetaData()
	getLibPhoneNumberMinMetaData(true)
}
